document.addEventListener("DOMContentLoaded", function () {
  // Recipe filter state
  const recipeFilter = {
    currentPage: 1,
    currentProtein: "all",
    loading: false,
    perPage: 6
  };

  // DOM elements
  const recipesGrid = document.getElementById("recipes-grid");
  const pagination = document.getElementById("recipes-pagination");
  const loader = document.querySelector(".recipes-loader");
  const proteinFilters = document.querySelectorAll(".protein-filter");
  const proteinFiltersMobile = document.querySelector(".recipes-filter__controls-mobile");
  if (recipesGrid) {
    // Initialize the recipes view
    loadRecipes("all", 1);

    // Add event listeners to protein filters
    proteinFilters.forEach(filter => {
      filter.addEventListener("click", function () {
        // Skip if already active
        if (this.classList.contains("active")) {
          return;
        }

        // Update active filter
        proteinFilters.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");

        // Update filter state
        recipeFilter.currentProtein = this.dataset.protein;
        recipeFilter.currentPage = 1;
        proteinFiltersMobile.value = recipeFilter.currentProtein;

        // Load filtered recipes
        loadRecipes(recipeFilter.currentProtein, recipeFilter.currentPage);
      });
    });
    proteinFiltersMobile.addEventListener("change", function () {
      // Update active filter
      proteinFilters.forEach(btn => btn.classList.remove("active"));
      const selectedValue = this.value;
      const activeFilter = Array.from(proteinFilters).find(btn => btn.dataset.protein === selectedValue);
      if (activeFilter) {
        activeFilter.classList.add("active");
      }

      // Update filter state
      recipeFilter.currentProtein = selectedValue;
      recipeFilter.currentPage = 1;

      // Load filtered recipes
      loadRecipes(recipeFilter.currentProtein, recipeFilter.currentPage);
    });

    // Handle pagination click events (using event delegation)
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("pagination-link")) {
        e.preventDefault();
        const page = parseInt(e.target.dataset.page);
        if (page !== recipeFilter.currentPage && !recipeFilter.loading) {
          recipeFilter.currentPage = page;
          loadRecipes(recipeFilter.currentProtein, recipeFilter.currentPage);

          // Scroll to the top of the recipes section
          document.getElementById("recetas").scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  }

  /**
   * Load recipes via AJAX
   * @param {string} protein - The protein taxonomy term to filter by ('all' for no filter)
   * @param {number} page - The page number to load
   */
  function loadRecipes(protein, page) {
    // Show loading state
    recipeFilter.loading = true;
    recipesGrid.style.display = "none";
    pagination.style.display = "none";
    loader.style.display = "block";

    // Make AJAX request
    fetch(toledano_vars.ajaxurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        action: "load_filtered_recipes",
        protein: protein,
        page: page,
        per_page: recipeFilter.perPage
      })
    }).then(response => response.json()).then(data => {
      // Update recipes grid
      recipesGrid.innerHTML = data.recipes_html;

      // Update pagination
      pagination.innerHTML = data.pagination_html;

      // Hide loader
      loader.style.display = "none";
      recipesGrid.style.display = "block";
      pagination.style.display = "block";
      recipeFilter.loading = false;
    }).catch(error => {
      console.error("Error loading recipes:", error);
      recipesGrid.innerHTML = "<p>Ha ocurrido un error al cargar las recetas. Por favor, intenta de nuevo.</p>";
      recipesGrid.style.display = "block";
      pagination.style.display = "block";
      loader.style.display = "none";
      recipeFilter.loading = false;
    });
  }
});